// extracted by mini-css-extract-plugin
export default {"container":"PageSpinner_container__dHN3q","load":"PageSpinner_load__J5sOR","spinner":"PageSpinner_spinner__AYpDu"};